// extracted by mini-css-extract-plugin
export default {"heading":"py-z","corrected":"qy-z","redirectVerbiageContainer":"ry-z","redirectVerbiageText":"sy-z"};